import React from "react";
import {Grid} from "@material-ui/core";
import backgroundImage from "../../../assets/images/main_background.png";
import TotalPrizesFrame from "../../pageComponents/Home/LeagueStart/TotalPrizesFrame";
import Toolbar from "../../Toolbar";
import GoldBanner from "../../../assets/images/gold_banner.png";
import Background from "../../../assets/images/back.png";
import GoldBannerIcon from "../../../assets/images/asset_2.png";
import axios from "axios";
import {sessionList, userData} from "../../../Utility/Url";
import {connect} from "react-redux";
import {data} from "../../../Store/Actions/DataAction";
import PicoLoader from "../../pageComponents/Common/PicoLoader";
import {withRouter} from "react-router-dom";
import startButton from "../../../assets/images/ic_start_btn.png";
import DialogContent from "@material-ui/core/DialogContent";
import TotalPrizeIntro from "../../pageComponents/Home/LeagueStart/TotalPrizeIntro";
import Dialog from "@material-ui/core/Dialog";
import Mesh from "../../../assets/images/mesh.png";
import star from "../../../assets/images/img_star.png";
import GreenButton from "../../../assets/images/green_btn.png";
import silverCoin from "../../../assets/images/ic_silver_coin.png";
import goldCoin from "../../../assets/images/ic_coin.png";
import CustomDialog from "../../pageComponents/Common/Dialog";
import Fail from "../../../assets/images/ic_faild.png";
import {stars} from "../../../Store/Actions/StarsAction";

class TotalPrizes extends React.Component {
    constructor(props) {
        super(props)
        this.state= {
            appHasLoaded: false,
            customDialogShow:false,
            customDialogData:null,
            showDialog:false,
            dialogData:{
                name:'',
                id:'',
                totalPrize:'',
                score:'',
                timeRemaining:'',
                backgroundColor:'',
                backgroundImage:'',
                prizeIcon:'',
                startButtonImage:'',
                startButtonText:'',
                startButtonIconText:'',
                leftSectionBottomImage:'',
                leftSectionTopImage:'',
            },
            pageTheme:{
                mainColor:'#f0a30a',
                name: 'برنزی'},
            style: {
                completed: 5,
                itemsLoaded:null,
                root: {
                    backgroundImage: "url(" + backgroundImage + ")",
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    width: '100%',
                    backgroundColor:'orange',
                    backgroundBlendMode:'soft-light',
                    color:'#F7DC5A',
                    flex:1,
                    minHeight:'0'
                },
            }
        }
    }
    fetchData= async()=>{
        await axios.get(userData)
            .then(res => {
                const {data}=res
                this.props.data(data)
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    fetchItems= async(id)=>{
        await axios.get(`${sessionList}/${id}`)
            .then(res => {
                const {data}=res
                this.setState({
                    itemsLoaded:data
                })
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    applyTheme=(id)=>{
        switch (id){
            case 'B':
                this.setState({
                    pageTheme:{
                        mainColor:'#f0a30a',
                        name:'برنزی',
                        image:'http://picopool.ir/_data/_plans/bronze_league_2.png'
                    }
                })
                break
            case 'S':
                this.setState({
                    pageTheme:{
                        mainColor:"#bdc3c7",
                        name:'نقره ای',
                        image:'http://picopool.ir/_data/_plans/silver_league_2.png'
                    }
                })
                break
            case 'G':
                this.setState({
                    pageTheme: {
                        mainColor: "#f1c40f",
                        name: 'طلایی',
                        image:'http://picopool.ir/_data/_plans/golden_league_2.png'
                    }
                })
                break
            case 'D':
                this.setState({
                    pageTheme: {
                        mainColor: "#9b59b6",
                        name: 'الماسی',
                        image:'http://picopool.ir/_data/_plans/diamond_league_2.png'
                    }
                })
                break
            default :this.setState({
                pageTheme: {
                    mainColor: '#f0a30a',
                    name: 'برنزی',
                    image:'http://picopool.ir/_data/_plans/golden_league_2.png'
                }
            })
        }
    }
    componentDidMount() {
        const{id}=this.props.match.params
        this.applyTheme(id)
        this.props.stars(true)
        this.props.toggleBottomNavbar()
        this.fetchItems(id)
        this.fetchData()
    }
    componentWillUnmount() {
        this.props.stars(false)
    }
    handleClose=(()=>{
        this.setState({
            showDialog:false
        })
    })
    setDialogData=(data)=>{
        const{id,
            locked,
            order,
            price_model,
            price_url,
            price_value,
            prize_model,
            prize_val,
            reqStars,
            stars,
            active}=data
        this.setState({ dialogData: { ...this.state.dialogData,
                name:` ${this.state.pageTheme.name}- مرحله ${order}`,
                id:id,
                totalPrize:'5',
                score:'45',
                timeRemaining:'22',
                backgroundColor:'rgba(0,0,0,0.4)',
                backgroundImage:Mesh,
                prizeIcon:star,
                startButtonImage:GreenButton,
                startButtonText:'شروع بازی',
                startButtonIcon:price_model==='silver'?silverCoin:goldCoin,
                startButtonIconText:price_value,
                leftSectionBottomImage:star,
                leftSectionTopImage:star,
            } });
        this.setState({
            showDialog:true
        })

        // this.setState({
        //     dialogData:{
        //         name:`برنزی - مرحله ${order}`,
        //         id:'2',
        //         totalPrize:'5',
        //         score:'45',
        //         timeRemaining:'22',
        //         backgroundColor:'rgba(0,0,0,0.4)',
        //         backgroundImage:Mesh,
        //         prizeIcon:star,
        //         startButtonImage:GreenButton,
        //         startButtonText:'شروع بازی',
        //         startButtonIcon:price_model==='silver'?silverCoin:goldCoin,
        //         startButtonIconText:price_value,
        //         leftSectionBottomImage:star,
        //         leftSectionTopImage:star,
        //     },
        //     showDialog:true
        // })
    }
    render() {
        let items=[
            {
                number:'5',
                price:null
            },
            {
                number:'5',
                price:'15000'
            },{
                number:'5',
                price:null
            },
            {
                number:'5',
                price:'15000'
            },{
                number:'5',
                price:null
            },
            {
                number:'5',
                price:'15000'
            },{
                number:'5',
                price:null
            },
            {
                number:'5',
                price:'15000'
            },{
                number:'5',
                price:null
            },
            {
                number:'5',
                price:'15000'
            },{
                number:'5',
                price:null
            },
            {
                number:'5',
                price:'15000'
            },{
                number:'5',
                price:null
            },
            {
                number:'5',
                price:'15000'
            },{
                number:'5',
                price:null
            },
            {
                number:'5',
                price:'15000'
            },{
                number:'5',
                price:null
            },
            {
                number:'5',
                price:'15000'
            },
        ]
        const {itemsLoaded,dialogData,customDialogShow,customDialogData,pageTheme}=this.state
        if (itemsLoaded)
        {
            items=itemsLoaded.list.map(data=>{
                return{
                    id: data.id,
                    locked: data.locked,
                    order: data.orderr,
                    price_model:data.price_model,
                    price_url:data.price_url,
                    price_value:data.price_value,
                    prize_model:data.prize_model,
                    prize_val:data.prize_val,
                    reqStars:data.reqStars,
                    stars:data.stars,
                    active:(!data.locked && data.stars==-1)
                }
            })
        }
        const customDialog={
            button:{
                text:'',
                backgroundColor:'transparent',
                bottomFontSize:'15px',
                buttonTextColor:'red',
                borderColor:'transparent'
            },
            data:{
                dialog: {...customDialogData,icon:Fail,
                },
            }
        }
        return(
            <Grid direction={"column"} item container style={{...this.state.style.root, backgroundColor: pageTheme.mainColor}}>
                {
                    itemsLoaded &&
                    <Grid item sm={12} xs={12} direction={"column"} justify={'center'} container
                          style={{flex: '1', minHeight: '0'}}
                    >
                        <Dialog
                            // disableBackdropClick
                            open={customDialogShow}
                            onClose={this.handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            style={{background:'transparent !important'}}
                            PaperProps={{
                                style: {
                                    backgroundColor: 'transparent',
                                    boxShadow: 'none',
                                },
                            }}
                        >
                            <DialogContent>
                                <CustomDialog action={this.handleDialogAction} data={customDialog}/>
                            </DialogContent>
                        </Dialog>
                        <Dialog
                            open={this.state.showDialog}
                            onClose={this.handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            style={{background:'transparent !important',overflow:'visible'}}
                            PaperProps={{
                                style: {
                                    backgroundColor: 'transparent',
                                    boxShadow: 'none',
                                    overflow:'visible',
                                },
                            }}
                        >
                            <DialogContent style={{overflow:'visible'}}>
                                <TotalPrizeIntro data={dialogData}/>
                            </DialogContent>
                        </Dialog>
                        <Grid item container>
                            <Toolbar type='sideToolbar'/>
                        </Grid>
                        <Grid item container xs={12} justify={"center"} sm={12} alignItems={"flex-start"}
                              className='scrollBar'
                              style={{flex: '1', minHeight: '0', overflow: 'auto'}}>
                            <Grid xs={11} sm={11} container justify={"center"} alignItems={"center"} item
                                  style={{
                                      alignSelf: 'flex-end',
                                      position: 'relative',
                                      backgroundImage: "url(" + GoldBanner + ")",
                                      backgroundSize: 'contain',
                                      backgroundRepeat: 'no-repeat',
                                      backgroundPosition: 'center',
                                      maxHeight:'125px',
                                      height:'75px'
                                  }}>
                                <Grid xs={2} sm={2} container justify={"center"} alignItems={"center"}>
                                    <p style={{color:'#ffffff'}}>
                                        {pageTheme.name}
                                    </p>
                                </Grid>
                                <Grid xs={2} sm={2} container justify={"center"} alignItems={"center"}>
                                    <img src={pageTheme.image} alt=""/>
                                </Grid>

                            </Grid>
                            {
                                items.map((data, key) => {
                                    return <Grid item container xs={3} justify={"center"} alignItems={"center"} sm={3}
                                                 style={{overflow:'visible'}}
                                                 onClick={()=>{
                                                     this.setDialogData(data)
                                                 }}
                                    >
                                        <TotalPrizesFrame identifier={key} data={data}/>
                                    </Grid>
                                })
                            }
                        </Grid>
                    </Grid>
                }
                {
                    !itemsLoaded &&
                    <Grid m={2} xs={2} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                          style={{
                              position: 'relative',
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%,-50%)'
                          }}
                    >
                        <Grid item container justify={"center"} style={{
                            position: 'absolute',
                        }}>
                            <PicoLoader/>
                        </Grid>
                    </Grid>
                }
            </Grid>
        )
    }
}
const mapStateToProps=state=>({
    UserData:state.UserData,
    Stars:state.Stars,
})
export default connect(mapStateToProps,{data,stars})(withRouter (TotalPrizes))